import React from "react";
import type { PropsWithChildren } from "react";

import { verticalProductBody } from "./VerticalProductCard.css";

export const VerticalProductCardBody: React.FC<PropsWithChildren> = ({
  children
}) => {
  return <div className={verticalProductBody}>{children}</div>;
};
